import { Banner } from "../Api";

export const getBanner = (banners: Banner[], page: string) => {
    let pageBanners = banners.filter(b => b?.location.includes(page))
    return pageBanners[0]
}